export default "__VITE_ASSET__BMusPCJJ__"